import React from 'react';

function Header() {
  return (
      <footer class="page-footer section">
        <div class="container">

          <p>Made by <a
            class="us"
            href="https://github.com/Breacher1337"
            target="_blank"
            rel="noopener noreferrer"
            >Elaijah.</a></p>
          
        </div>
    </footer>
    
  );
}

export default Header;
